<template>
    <spinner v-if="isLoading" />

    <transition name="fade">
        <div>
            <BreadCrumbs :breadCrumbs="breadCrumbs" :title="title" :back_title="backTitle" :link="link" />

            <div class="page">
                <h2 class="mb-4">Слайдер: {{ slider.name }}</h2>

                <!-- Загрузка новых фото -->
                <div class="mb-4 d-flex align-items-center gap-3">
                    <input type="file" multiple @change="handleFiles" />
                    <Button v-if="selectedFiles.length" caption="Загрузить" color="btn-green" @click="uploadSelected" />
                </div>

                <!-- Список фото -->
                <table v-if="images && images.length" class="slider-images-table">
                    <tbody>
                        <tr v-for="img in images" :key="img.id">
                            <td class="thumb-cell">
                                <img :src="img.url" class="thumb" />
                            </td>
                            <td class="status-cell">
                                <label class="form-check">
                                    <input type="checkbox" class="form-check-input" v-model="img.status"
                                        @change="toggleStatus(img)" />
                                    <span class="form-check-label">Активен</span>
                                </label>
                            </td>
                            <td class="actions-cell">
                                <Button color="btn-red" btn_icon="delete" @click="deleteImage(img.id)" />
                            </td>
                        </tr>
                    </tbody>
                </table>
                <p v-else>Нет фотографий</p>
            </div>
        </div>
    </transition>
</template>

<script>
import Spinner from '../../../components/Spinner.vue';
import BreadCrumbs from '../../../Page/BreadCrumbs.vue';
import Button from '../../../components/Button.vue';
import {
    fetchSlider,
    uploadSliderImages,
    deleteSliderImage,
    toggleSliderImageStatus
} from '../../../services/boards';

export default {
    name: 'SliderDetail',
    components: { Spinner, BreadCrumbs, Button },
    data() {
        return {
            slider: { name: '' },
            images: [],
            selectedFiles: [],
            isLoading: false,
            boardId: 2,   // или берите из this.$route.params.boardId
            // для BreadCrumbs:
            breadCrumbs: true,
            title: '',             // подставим в mounted
            backTitle: 'Слайдеры',
            link: 'boards/doska-to/sliders'
        };
    },
    mounted() {
        this.loadSlider();
    },
    methods: {
        // Загрузка данных слайдера и его изображений
        async loadSlider() {
            this.isLoading = true;
            try {
                const data = await fetchSlider(
                    this.boardId,
                    this.$route.params.sliderId
                );
                this.slider = data;
                this.title = data.name;
                this.images = data.images || [];
            } catch (e) {
                console.error(e);
            } finally {
                this.isLoading = false;
            }
        },

        // Обработка выбора файлов и загрузка их на сервер
        async handleFiles(event) {
            const files = Array.from(event.target.files);
            if (!files.length) return;

            this.isLoading = true;
            try {
                // 1) Загружаем
                await uploadSliderImages(
                    this.boardId,
                    this.$route.params.sliderId,
                    files
                );
                // 2) Очищаем input, чтобы можно было выбрать те же файлы заново
                event.target.value = null;
                // 3) Перезагружаем полностью слайдер вместе с новыми изображениями
                await this.loadSlider();
            } catch (e) {
                console.error("Upload error:", e.response || e);
                alert("Ошибка при загрузке: " + (e.response?.data?.message || e.message));
            } finally {
                this.isLoading = false;
            }
        },

        // Удаление одной фотографии
        async deleteImage(imageId) {
            if (!confirm('Удалить фото?')) return;
            this.isLoading = true;
            try {
                await deleteSliderImage(
                    this.boardId,
                    this.$route.params.sliderId,
                    imageId
                );
                this.images = this.images.filter(i => i.id !== imageId);
            } catch (e) {
                console.error(e);
            } finally {
                this.isLoading = false;
            }
        },

        // Переключение статуса (активен/неактивен)
        async toggleStatus(img) {
            this.isLoading = true;
            try {
                await toggleSliderImageStatus(
                    this.boardId,
                    this.$route.params.sliderId,
                    img.id,
                );
            } catch (e) {
                console.error(e);
            } finally {
                this.isLoading = false;
            }
        }
    }

};
</script>

<style scoped>
.slider-images-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 8px; /* вертикальный отступ между строками */
}

.slider-images-table td {
  background: #fff;
  vertical-align: middle;
  padding: 0.5rem 1rem;
  border: none;
}

.slider-images-table tr:hover td {
  background: #f9f9f9;
}

.thumb-cell {
  width: 140px;
}

.thumb {
  display: block;
  width: 120px;
  height: auto;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.status-cell {
  width: 150px;
  text-align: center;
}

.actions-cell {
  width: 80px;
  text-align: center;
}
</style>
